module.exports = __webpack_public_path__ + "img/logo-the-dutch-masters.667d233d.jpg";